import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AdminUserViewLayer from "../components/AdminUserViewLayer";

const AdminRegistrationViewPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* AdminUserViewLayer */}
                <AdminUserViewLayer />
            </MasterLayout>
        </>
    );
};

export default AdminRegistrationViewPage;
